import React from "react";
import classNames from "classnames";
import { Identifiable, Role } from "@planzone/dto";
import { useRolesRetrieval } from "@planzone/view-models";
import { useTranslation } from "react-i18next";
import { SelectedIcon } from "@common/selectedIcon";
import { SelectList } from "@common/selectList";
import { Props } from "./types";
import { ArrowIcon } from "./arrowIcon";
import styles from "./styles.scss";

function RoleSelection(props: Props) {
  const { t } = useTranslation();
  const { roles } = useRolesRetrieval();
  const selectedRoles = roles.filter((role) =>
    props.selectedRoleIds.find((id) => id === role.uuid || id === role.name),
  );
  const isPlanzoneRole = (role: Identifiable<Role>) =>
    role.name.slice(0, "pz_".length) === "pz_";

  return (
    <SelectList
      rootClassName={styles.roleSelection}
      listClassName={styles.listRoot}
    >
      {({ isOpen }) => ({
        input: (
          <div
            className={classNames(styles.input, {
              [styles.openedInput]: isOpen,
            })}
          >
            {selectedRoles.length > 0 ? (
              <p className={styles.selectedRoles}>
                {selectedRoles
                  .map(({ name }) => t(`roles.${name}`, name))
                  .join(", ")}
              </p>
            ) : (
              <p className={styles.textHidden}>e</p>
            )}
            {isOpen ? (
              <div>
                <ArrowIcon className={styles.iconOpen} />
              </div>
            ) : (
              <ArrowIcon className={styles.iconClose} />
            )}
          </div>
        ),
        list: (
          <div className={styles.list}>
            {roles.filter(isPlanzoneRole).map((role, key) => {
              const isSelected = props.selectedRoleIds.find(
                (id) => id === role.uuid || id === role.name,
              );

              return (
                <div
                  key={key}
                  className={styles.role}
                  onClick={() =>
                    isSelected ? props.unSelect(role) : props.select(role)
                  }
                >
                  {isSelected ? (
                    <div className={styles.selectedRole}>
                      <div className={styles.selectedRoleTitle}>
                        {t(`roles.${role.name}`, role.name)}{" "}
                        <SelectedIcon className={styles.selectedRoleIcon} />
                      </div>
                    </div>
                  ) : (
                    <div>{t(`roles.${role.name}`, role.name)}</div>
                  )}
                </div>
              );
            })}
          </div>
        ),
      })}
    </SelectList>
  );
}

export { RoleSelection };
